<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "3rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M5.5 16A1.5 1.5 0 014 14.52V6a2 2 0 012-2h8.51a1.5 1.5 0 110 3H7v7.51A1.5 1.5 0 015.5 16zM42.5 16a1.5 1.5 0 01-1.5-1.5V7h-7.51a1.5 1.5 0 010-3H42a2 2 0 012 2v8.51A1.5 1.5 0 0142.5 16zM14.51 44H6a2 2 0 01-2-2v-8.52a1.5 1.5 0 013 0V41h7.51a1.5 1.5 0 110 3zM44 42a2 2 0 01-2 2h-8.51a1.5 1.5 0 010-3H41v-7.51a1.5 1.5 0 113 0zM17.53 16.19h1.25v16h-1.25zM25.7 16.19h1.25v16H25.7zM34.21 16.19h1.25v16h-1.25zM12.54 16.19h3.21v16h-3.21zM20.33 16.19h3.21v16h-3.21zM29.23 16.19h3.21v16h-3.21z"/></svg>